import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import React, { createContext, useEffect, useRef, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { APP_NAME,CLIENT_CODE,RHYBUS_ACCESS_TOKEN } from '../Configuration'
import { handleScroll } from '../assets/ts/general/general'
import { loginRequest } from "../authConfig"
import ClassificationBanner from '../components/banner/classification-banner'
import { Footer, Header, Menus } from '../layouts/index'
import {
  Announcements,
  AppConfig,
  ArchivedInquiries,
  CalendarInnerview,
  CompletedInquiries,
  DetailView,
  DueOuts,
  DueoutDetailView,
  DueoutForm,
  Home,
  Inquiries,
  InquiryForm,
  InvalidPageRequest,
  KnowledgeBase,
  MyInquiries,
  PII,
  PointsOfContacts,
  PolicyMemosGuidelines,
  Profile,
  QuestionAndAnswer,
  QuickLinks,
  ReleaseNotes,
  Settings,
  SiteFeedback,
} from '../pages/index'
import Layout from '../pages/layout'
import SurveyReport from '../pages/surveyreport/customerSurvey'
import SurveyForm from '../pages/surveyreport/customerSurveyForm'
import TestExample from '../utils/tools/test-example'
import TestingPlayground from '../utils/tools/testing-playground'

const scrollContext = createContext<React.RefObject<{
  onScroll: () => void
}> | null>(null)

const Routers = () => {
  const userProfileRef = useRef<{ onScroll: () => void }>(null)
  const [isMenusExpanded, setIsMenuExpanded] = useState<boolean>(false)
   const { accounts, instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const onBottomReached = () => {
    if (userProfileRef.current) {
      userProfileRef.current.onScroll()
    }
  }
  useEffect(() => {
    const rhybusAccessToken = async () => {
      if (isAuthenticated && accounts.length > 0) {
        await instance
          .acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          })
          .then((response) => {
          localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
          localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken)
          localStorage.setItem(CLIENT_CODE,APP_NAME)
          })
      }
    }

    rhybusAccessToken()
  }, [isAuthenticated, accounts])
  return (
    <scrollContext.Provider value={userProfileRef}>
      <>
        <ClassificationBanner classification='UNCLASSIFIED/FOUO - PII Authorized' colorID={54} />
        <div className='side-menus'>
          <BrowserRouter>
            <div className='mainwrapper'>
              <Menus setIsMenuExpanded={setIsMenuExpanded} />
              <div className='content-wrapper'>
                <Header />
                <div
                  className='wrapper'
                  id='wrapper'
                  onScroll={(e) => handleScroll(e, undefined, onBottomReached)}
                >
                  <Routes>
                    <Route element={<Layout />}>
                      <Route element={<Home />} path='/' />
                      <Route element={<Profile />} path='/profile' />
                      <Route
                        element={<Inquiries isMenusExpanded={isMenusExpanded} />}
                        path='/inquiries'
                      />
                      <Route element={<MyInquiries />} path='/myinquiries-dueouts' />
                      <Route element={<DueOuts />} path='/dueouts' />
                      <Route element={<CompletedInquiries />} path='/completedinquiries' />
                      <Route element={<ArchivedInquiries />} path='/archivedinquiries' />
                      <Route
                        element={
                          <CalendarInnerview
                            onClose={() => {
                              return
                            }}
                          />
                        }
                        path='/calendar'
                      />
                      <Route element={<KnowledgeBase />} path='/knowledgebase' />
                      <Route element={<QuestionAndAnswer />} path='/qanda' />
                      <Route element={<QuickLinks />} path='/quicklinks' />
                      <Route element={<Announcements />} path='/announcements' />
                      <Route element={<PointsOfContacts />} path='/pointsofcontact' />
                      <Route element={<PolicyMemosGuidelines />} path='/policymemos-guidelines' />
                      <Route element={<PII />} path='/pii' />
                      <Route
                        element={<Settings isMenusExpanded={isMenusExpanded} />}
                        path='/settings'
                      />
                      <Route element={<SiteFeedback />} path='/sitefeedback' />
                      <Route element={<ReleaseNotes />} path='/releasenotes' />
                      <Route
                        element={<DetailView isMenusExpanded={isMenusExpanded} />}
                        path='/detailview'
                      />
                      <Route
                        element={<DetailView isMenusExpanded={isMenusExpanded} />}
                        path='/detailview/:guid'
                      />
                      <Route
                        element={<DueoutDetailView isMenusExpanded={isMenusExpanded} />}
                        path='/dueoutdetailview'
                      />
                      <Route
                        element={<DueoutDetailView isMenusExpanded={isMenusExpanded} />}
                        path='/dueoutdetailview/:guid'
                      />
                      <Route element={<InquiryForm />} path='/createinquiry' />
                      <Route element={<InquiryForm />} path='/createinquiry/:guid' />
                      <Route element={<DueoutForm />} path='/createdueout' />
                      <Route element={<DueoutForm />} path='/createdueout/:guid' />
                      <Route element={<InvalidPageRequest />} path='/accessdenied' />
                      <Route element={<TestingPlayground />} path='/testingplayground' />
                      <Route element={<TestExample />} path='/testexample' />{' '}
                    </Route>
                    <Route element={<AppConfig />} path='/appconfig' />
                    <Route element={<InvalidPageRequest />} path='*' />
                    <Route element={<SurveyReport />} path='/surveyreport' />
                    <Route element={<SurveyForm />} path='/surveyform' />
                    <Route element={<SurveyForm />} path='/surveyform/:guid' />
                  </Routes>
                </div>
                {/* <Footer /> */}
              </div>
            </div>
          </BrowserRouter>
        </div>
      </>
    </scrollContext.Provider>
  )
}

export default Routers
export { scrollContext }
